import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import {
  TABS_DEFAULTS,
  TABS_VARIANT_CLASS_MAP,
  type TTabsListElement,
  type TTabsListProps,
} from "@/ui/components/navigation/Tabs/Tabs.config";
import { cn } from "@/ui/lib/utils";
import { ScrollArea } from "../../primitives";

export const TabsList = forwardRef<TTabsListElement, TTabsListProps>(
  (
    {
      className,
      variant = TABS_DEFAULTS.variant,
      hidden,
      children,
      ...props
    },
    ref,
  ) => {
    if (hidden) { return null; }
    return (
      <ScrollArea
        orientation="horizontal"
      >
        <TabsPrimitive.List
          data-component="TabsList"
          ref={ref}
          className={cn(
            "flex",
            TABS_VARIANT_CLASS_MAP[variant].list,
            className,
          )}
          {...props}
        >
          { children }
        </TabsPrimitive.List>
      </ScrollArea>
    );
  },
);

TabsList.displayName = TabsPrimitive.List.displayName;
